import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { CabecalhoInstitucional } from '../../components/CabecalhoInstitucional';
import { RodapeInstitucional } from '../../components/RodapeInstitucional';
import { TelefoneDemoWhatsApp } from '../../components/TelefoneDemoWhatsApp';
import { TelefoneMapaRota } from '../../components/TelefoneMapaRota';
import { BotaoFlutuanteWhatsApp } from '../../components/BotaoFlutuanteWhatsApp';
import { BotaoVoltarAoTopo } from '../../components/BotaoVoltarAoTopo';

const PONTOS_FORTES = [
  {
    titulo: 'Tudo em um só lugar',
    descricao: 'Cardápio, pedidos, cozinha, estoque, equipe e financeiro no mesmo sistema — sem colar 5 apps diferentes.',
  },
  {
    titulo: 'Inteligência, não só cadastro',
    descricao: 'CMV, margem de lucro e encargos CLT calculados automaticamente a cada mudança — você não faz conta na mão.',
  },
  {
    titulo: 'Cardápio sem custo de impressão',
    descricao: 'QR Code gerado na hora, sempre atualizado. Mudou o preço? O cliente já vê o novo na próxima leitura.',
  },
  {
    titulo: 'Feito para a realidade brasileira',
    descricao: 'Encargos CLT, LGPD e suporte em português, direto com o time — não é um sistema traduzido de fora.',
  },
];

const RECURSOS = [
  {
    icone: '📋',
    titulo: 'Cardápio com QR Code',
    descricao: 'Monte categorias e produtos e gere um cardápio digital acessível por QR Code, sem precisar de login.',
  },
  {
    icone: '🧑‍🍳',
    titulo: 'Pedido rápido e KDS',
    descricao: 'Cliente faz o pedido pelo celular e ele cai em tempo real na tela da cozinha, com baixa automática no estoque.',
  },
  {
    icone: '📦',
    titulo: 'Matéria-prima e CMV',
    descricao: 'Cadastre a ficha técnica dos produtos e acompanhe o custo (CMV) e a margem de lucro de cada item.',
  },
  {
    icone: '💰',
    titulo: 'Financeiro simples',
    descricao: 'Lance entradas e saídas com contas já pré-cadastradas (luz, água, aluguel, internet) e veja o saldo na hora.',
  },
  {
    icone: '👥',
    titulo: 'Equipe e encargos CLT',
    descricao: 'Cadastre funcionários e veja o custo real da equipe, com o cálculo automático dos encargos CLT.',
  },
  {
    icone: '📊',
    titulo: 'Relatórios reunidos',
    descricao: 'Entradas x saídas, ficha técnica, custo por equipe e melhor/pior dia de venda, tudo em um só lugar.',
  },
];

const INTEGRACOES = [
  { nome: 'iFood', cor: '#EA1D2C' },
  { nome: 'Rappi', cor: '#FF441F' },
  { nome: 'Uber Eats', cor: '#06C167' },
  { nome: '99Food', cor: '#FFCC00', corTexto: '#111b21' },
];

const PASSOS_MOTOBOY = [
  {
    titulo: 'Motoboy tira a foto do endereço',
    descricao: 'Sem digitar nada: o motoboy fotografa o endereço de entrega direto pelo celular.',
  },
  {
    titulo: 'Rota e KM calculados na hora',
    descricao: 'O sistema reconhece o endereço e já traça a rota automaticamente, igual ao Waze — sem retrabalho.',
  },
  {
    titulo: 'Você acompanha em tempo real',
    descricao: 'Todo o trajeto da entrega fica visível dentro do próprio Lizzi Food, do pedido até a porta do cliente.',
  },
];

const DEPOIMENTOS = [
  {
    frase: 'Desde que passamos a usar o Lizzi Food, o financeiro parou de ser uma dor de cabeça. Vejo entrada e saída na hora, sem planilha.',
    nome: 'Marcos Aurélio',
    estabelecimento: 'Restaurante Sabor Caseiro',
  },
  {
    frase: 'O pedido cai direto na tela da cozinha e o estoque já baixa sozinho. Antes eu perdia tempo conferindo tudo na mão.',
    nome: 'Juliana Ferreira',
    estabelecimento: 'Hamburgueria Point 22',
  },
  {
    frase: 'O que mais gostei foi o rastreio do motoboy em tempo real. O cliente acompanha a entrega e para de ligar perguntando.',
    nome: 'Rodrigo Almeida',
    estabelecimento: 'Pizzaria Dona Rosa',
  },
];

const PRECO_MENSAL = 70;
const DESCONTO_ANUAL = 0.1;
const PRECO_ANUAL_TOTAL = Math.round(PRECO_MENSAL * 12 * (1 - DESCONTO_ANUAL));
const PRECO_ANUAL_EQUIVALENTE_MES = Math.round(PRECO_ANUAL_TOTAL / 12);

const FUNCIONALIDADES_PLANO = [
  'Cardápio digital + QR Code',
  'Pedidos + tela da cozinha',
  'Estoque, CMV e margem',
  'Equipe, financeiro e relatórios',
  'Integração com iFood, Rappi, Uber Eats e 99Food',
  'Rastreamento do motoboy em tempo real',
];

export function LandingPage() {
  return (
    <div>
      <CabecalhoInstitucional />

      {/* Hero */}
      <Container style={{ maxWidth: '1140px' }} className="py-4 py-lg-5">
        <Row className="align-items-center g-4">
          <Col lg={7}>
            <h1 style={{ fontSize: '42px', lineHeight: 1.15, fontWeight: 800, margin: '0 0 16px' }}>
              A gestão do seu restaurante, do cardápio ao financeiro.
            </h1>
            <p style={{ fontSize: '18px', color: 'var(--cor-texto)', margin: '0 0 20px', maxWidth: '520px' }}>
              O Lizzi Food reúne cardápio digital, pedidos, cozinha, estoque, equipe e financeiro em um único sistema
              simples, feito para o dia a dia de quem cozinha e vende.
            </p>
            <p style={{ fontSize: '14px', fontWeight: 600, color: 'var(--cor-primaria)', margin: '0 0 28px' }}>
              Integração nativa com iFood · Rappi · Uber Eats · 99Food
            </p>
            <div className="d-flex gap-3 flex-wrap">
              <Link
                to="/cadastro"
                className="btn btn-lg fw-bold text-white"
                style={{ background: 'var(--cor-gradiente)', border: 'none' }}
              >
                Começar agora, é grátis
              </Link>
              <a href="#precos" className="btn btn-lg btn-outline-primary fw-bold">
                Ver planos
              </a>
            </div>
            <p style={{ fontSize: '13px', color: 'var(--cor-texto)', marginTop: '14px' }}>
              Sem cartão de crédito · cancele quando quiser
            </p>
          </Col>
          <Col lg={5}>
            <TelefoneDemoWhatsApp />
          </Col>
        </Row>
      </Container>

      {/* Pontos fortes */}
      <div style={{ background: 'var(--cor-branco)', padding: '64px 0' }}>
        <Container style={{ maxWidth: '1140px' }}>
          <h2 style={{ fontSize: '28px', textAlign: 'center', marginBottom: '8px', fontWeight: 700 }}>
            Por que restaurantes escolhem o Lizzi Food
          </h2>
          <p style={{ textAlign: 'center', color: 'var(--cor-texto)', marginBottom: '40px' }}>
            Não é só mais um sistema de cadastro — é gestão de verdade.
          </p>
          <Row className="g-4">
            {PONTOS_FORTES.map((ponto) => (
              <Col md={6} key={ponto.titulo}>
                <div className="d-flex gap-3">
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      background: 'var(--cor-gradiente)',
                      color: '#fff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700,
                      flexShrink: 0,
                    }}
                  >
                    ✓
                  </div>
                  <div>
                    <h3 style={{ fontSize: '17px', margin: '0 0 6px' }}>{ponto.titulo}</h3>
                    <p style={{ fontSize: '14px', color: 'var(--cor-texto)', margin: 0 }}>{ponto.descricao}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Recursos */}
      <Container id="recursos" style={{ maxWidth: '1140px' }} className="py-5">
        <h2 style={{ fontSize: '28px', textAlign: 'center', marginBottom: '32px', fontWeight: 700 }}>
          Tudo que o seu restaurante precisa
        </h2>
        <Row className="g-4">
          {RECURSOS.map((recurso) => (
            <Col md={4} key={recurso.titulo}>
              <Card
                className="cartao-com-hover"
                style={{ height: '100%', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio-padrao)' }}
              >
                <Card.Body>
                  <div
                    style={{
                      width: '44px',
                      height: '44px',
                      borderRadius: '12px',
                      background: 'rgba(30,86,232,0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '22px',
                      marginBottom: '14px',
                    }}
                  >
                    {recurso.icone}
                  </div>
                  <Card.Title style={{ fontSize: '16px' }}>{recurso.titulo}</Card.Title>
                  <Card.Text style={{ fontSize: '14px', color: 'var(--cor-texto)' }}>{recurso.descricao}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}

          {/* Card dedicado de integração com apps de entrega */}
          <Col md={12}>
            <Card
              className="cartao-com-hover"
              style={{
                border: '1px solid var(--cor-borda)',
                borderRadius: 'var(--raio-padrao)',
                background: 'var(--cor-fundo)',
              }}
            >
              <Card.Body className="p-4">
                <Row className="align-items-center g-4">
                  <Col md={5}>
                    <div
                      style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '12px',
                        background: 'rgba(30,86,232,0.1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '22px',
                        marginBottom: '14px',
                      }}
                    >
                      🔗
                    </div>
                    <Card.Title style={{ fontSize: '18px' }}>Integração nativa com apps de entrega</Card.Title>
                    <Card.Text style={{ fontSize: '14px', color: 'var(--cor-texto)' }}>
                      Conecte diretamente com os principais apps do mercado e receba os pedidos direto na sua
                      cozinha, sem digitar nada duas vezes.
                    </Card.Text>
                  </Col>
                  <Col md={7}>
                    <div className="d-flex flex-wrap gap-3 justify-content-md-end">
                      {INTEGRACOES.map((app) => (
                        <span
                          key={app.nome}
                          className="selo-integracao"
                          style={{
                            background: app.cor,
                            color: app.corTexto ?? '#fff',
                            fontWeight: 700,
                            fontSize: '14px',
                            padding: '10px 20px',
                            borderRadius: '10px',
                            boxShadow: '0 4px 10px rgba(0,0,0,0.15)',
                          }}
                        >
                          {app.nome}
                        </span>
                      ))}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Diferencial: motoboy em tempo real */}
      <div style={{ background: 'var(--cor-branco)', padding: '64px 0' }}>
        <Container style={{ maxWidth: '1140px' }}>
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <p
                style={{
                  fontSize: '13px',
                  fontWeight: 700,
                  color: 'var(--cor-primaria)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.06em',
                  margin: '0 0 8px',
                }}
              >
                Nosso diferencial
              </p>
              <h2 style={{ fontSize: '28px', fontWeight: 700, margin: '0 0 12px' }}>
                Rastreamento do motoboy em tempo real
              </h2>
              <p style={{ color: 'var(--cor-texto)', marginBottom: '28px', maxWidth: '480px' }}>
                Chega de ligar para saber onde está a entrega. O Lizzi Food traça a rota sozinho e mostra tudo em
                tempo real para você e para o cliente.
              </p>
              <div className="d-flex flex-column gap-4">
                {PASSOS_MOTOBOY.map((passo, indice) => (
                  <div className="d-flex gap-3" key={passo.titulo}>
                    <div
                      style={{
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        background: 'var(--cor-gradiente)',
                        color: '#fff',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      {indice + 1}
                    </div>
                    <div>
                      <h3 style={{ fontSize: '16px', margin: '0 0 4px' }}>{passo.titulo}</h3>
                      <p style={{ fontSize: '14px', color: 'var(--cor-texto)', margin: 0 }}>{passo.descricao}</p>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
            <Col lg={6}>
              <TelefoneMapaRota />
            </Col>
          </Row>
        </Container>
      </div>

      {/* Prova social */}
      <div style={{ background: 'var(--cor-branco)', padding: '56px 0' }}>
        <Container style={{ maxWidth: '1000px' }} className="text-center">
          <h2 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '8px' }}>
            Quem usa recomenda
          </h2>
          <p style={{ color: 'var(--cor-texto)', marginBottom: '32px' }}>
            Restaurantes que já simplificaram a gestão do dia a dia com o Lizzi Food.
          </p>
          <Row className="g-4">
            {DEPOIMENTOS.map((depoimento) => (
              <Col md={4} key={depoimento.nome}>
                <Card
                  className="cartao-com-hover"
                  style={{ height: '100%', border: '1px solid var(--cor-borda)', borderRadius: 'var(--raio-padrao)' }}
                >
                  <Card.Body className="text-start d-flex flex-column">
                    <span style={{ color: 'var(--cor-dourado)', fontSize: '14px', marginBottom: '10px' }}>
                      ★★★★★
                    </span>
                    <p style={{ fontSize: '14px', color: 'var(--cor-texto)', flex: 1 }}>“{depoimento.frase}”</p>
                    <p style={{ fontSize: '13px', fontWeight: 700, margin: '12px 0 0' }}>{depoimento.nome}</p>
                    <p style={{ fontSize: '12px', color: 'var(--cor-texto)', margin: 0 }}>{depoimento.estabelecimento}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </div>

      {/* Preço */}
      <Container id="precos" style={{ maxWidth: '900px' }} className="py-5 text-center">
        <h2 style={{ fontSize: '28px', fontWeight: 700, marginBottom: '8px' }}>Escolha o plano ideal para você</h2>
        <p style={{ color: 'var(--cor-texto)', marginBottom: '40px' }}>
          Nos dois planos, todos os módulos vêm incluídos: cardápio, pedidos, KDS, estoque, equipe, financeiro e
          relatórios.
        </p>

        <Row className="g-4 justify-content-center">
          <Col md={6}>
            <Card
              className="h-100 cartao-com-hover"
              style={{ border: '1px solid var(--cor-borda)', borderRadius: '16px' }}
            >
              <Card.Body className="p-4 d-flex flex-column">
                <p
                  style={{
                    fontSize: '13px',
                    fontWeight: 700,
                    color: 'var(--cor-primaria)',
                    textTransform: 'uppercase',
                    margin: '0 0 8px',
                  }}
                >
                  Plano Mensal
                </p>
                <div style={{ fontSize: '42px', fontWeight: 800 }}>
                  R$ {PRECO_MENSAL.toFixed(2)}
                  <span style={{ fontSize: '16px', fontWeight: 500 }}>/mês</span>
                </div>
                <p style={{ fontSize: '13px', color: 'var(--cor-texto)' }}>Cobrado mensalmente · cancele quando quiser</p>
                <Link
                  to="/cadastro"
                  className="btn w-100 fw-bold text-white mt-3"
                  style={{ background: 'var(--cor-gradiente)', border: 'none', padding: '12px' }}
                >
                  Criar minha conta
                </Link>
                <ul style={{ listStyle: 'none', padding: 0, marginTop: '20px', textAlign: 'left', fontSize: '14px', flex: 1 }}>
                  {FUNCIONALIDADES_PLANO.map((item) => (
                    <li key={item} className="d-flex align-items-center gap-2 mb-2">
                      <span style={{ color: 'var(--cor-sucesso)' }}>✓</span> {item}
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>

          <Col md={6}>
            <Card
              className="h-100 cartao-com-hover"
              style={{ border: '2px solid var(--cor-primaria)', borderRadius: '16px', boxShadow: 'var(--sombra-elevada)' }}
            >
              <Card.Body className="p-4 d-flex flex-column">
                <div className="d-flex align-items-center justify-content-between">
                  <p
                    style={{
                      fontSize: '13px',
                      fontWeight: 700,
                      color: 'var(--cor-primaria)',
                      textTransform: 'uppercase',
                      margin: '0 0 8px',
                    }}
                  >
                    Plano Anual
                  </p>
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: 700,
                      color: '#fff',
                      background: 'var(--cor-sucesso)',
                      borderRadius: '999px',
                      padding: '3px 10px',
                    }}
                  >
                    Economize 10%
                  </span>
                </div>
                <div style={{ fontSize: '42px', fontWeight: 800 }}>
                  R$ {PRECO_ANUAL_EQUIVALENTE_MES.toFixed(2)}
                  <span style={{ fontSize: '16px', fontWeight: 500 }}>/mês</span>
                </div>
                <p style={{ fontSize: '13px', color: 'var(--cor-texto)' }}>
                  R$ {PRECO_ANUAL_TOTAL.toFixed(2)}/ano cobrado uma vez
                </p>
                <Link
                  to="/cadastro"
                  className="btn w-100 fw-bold text-white mt-3"
                  style={{ background: 'var(--cor-gradiente)', border: 'none', padding: '12px' }}
                >
                  Criar minha conta
                </Link>
                <ul style={{ listStyle: 'none', padding: 0, marginTop: '20px', textAlign: 'left', fontSize: '14px', flex: 1 }}>
                  {FUNCIONALIDADES_PLANO.map((item) => (
                    <li key={item} className="d-flex align-items-center gap-2 mb-2">
                      <span style={{ color: 'var(--cor-sucesso)' }}>✓</span> {item}
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* CTA final */}
      <section
        style={{
          background: 'var(--cor-gradiente)',
          color: 'var(--cor-branco)',
          textAlign: 'center',
          padding: '56px 32px',
        }}
      >
        <h2 style={{ fontSize: '26px', margin: '0 0 12px', fontWeight: 700 }}>
          Pronto para simplificar a gestão do seu restaurante?
        </h2>
        <p style={{ margin: '0 0 24px' }}>Crie sua conta gratuitamente e comece a usar em minutos.</p>
        <Link to="/cadastro" className="btn btn-lg fw-bold" style={{ background: '#fff', color: 'var(--cor-primaria)' }}>
          Criar minha conta
        </Link>
      </section>

      <RodapeInstitucional />
      <BotaoVoltarAoTopo />
      <BotaoFlutuanteWhatsApp />
    </div>
  );
}
